function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgData = function SvgData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#424A60"
    },
    d: "M24,35v-0.375V34.25v-8.625V25.25h0.034C24.013,25.374,24,25.499,24,25.625 c0-2.437,3.862-4.552,9.534-5.625H3.608C1.616,20,0,21.615,0,23.608v11.783C0,37.385,1.616,39,3.608,39H24V35z"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M24.034,53H24v-9v-0.375V43.25V39H3.608C1.616,39,0,40.615,0,42.608v11.783 C0,56.385,1.616,58,3.608,58h28.718C27.601,56.931,24.378,55.103,24.034,53z"
  })), React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M54.392,20H3.608C1.616,20,0,18.384,0,16.392V4.608C0,2.616,1.616,1,3.608,1h50.783 C56.384,1,58,2.616,58,4.608v11.783C58,18.384,56.384,20,54.392,20z"
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 9.5,
    cy: 10.5,
    r: 3.5
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 49,
    cy: 9,
    r: 1
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 45,
    cy: 9,
    r: 1
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 51,
    cy: 12,
    r: 1
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 47,
    cy: 12,
    r: 1
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 41,
    cy: 9,
    r: 1
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 43,
    cy: 12,
    r: 1
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 37,
    cy: 9,
    r: 1
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 39,
    cy: 12,
    r: 1
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 33,
    cy: 9,
    r: 1
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 35,
    cy: 12,
    r: 1
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 9.5,
    cy: 29.5,
    r: 3.5
  }), React.createElement("circle", {
    style: {
      fill: "#7383BF"
    },
    cx: 9.5,
    cy: 48.5,
    r: 3.5
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#1A9172"
    },
    d: "M42,48.75c-9.941,0-18-2.854-18-6.375V53h0.034c0.548,3.346,8.381,6,17.966,6s17.418-2.654,17.966-6 H60V42.375C60,45.896,51.941,48.75,42,48.75z"
  }), React.createElement("path", {
    style: {
      fill: "#1A9172"
    },
    d: "M24,42v0.375c0-0.126,0.013-0.251,0.034-0.375H24z"
  }), React.createElement("path", {
    style: {
      fill: "#1A9172"
    },
    d: "M59.966,42C59.987,42.124,60,42.249,60,42.375V42H59.966z"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#25AE88"
    },
    d: "M42,38c-9.941,0-18-2.854-18-6.375V42.75h0.034c0.548,3.346,8.381,6,17.966,6s17.418-2.654,17.966-6 H60V31.625C60,35.146,51.941,38,42,38z"
  }), React.createElement("path", {
    style: {
      fill: "#25AE88"
    },
    d: "M24,31.25v0.375c0-0.126,0.013-0.251,0.034-0.375H24z"
  }), React.createElement("path", {
    style: {
      fill: "#25AE88"
    },
    d: "M59.966,31.25C59.987,31.374,60,31.499,60,31.625V31.25H59.966z"
  })), React.createElement("ellipse", {
    style: {
      fill: "#88C057"
    },
    cx: 42,
    cy: 21.375,
    rx: 18,
    ry: 6.375
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#61B872"
    },
    d: "M42,27.75c-9.941,0-18-2.854-18-6.375V32h0.034c0.548,3.346,8.381,6,17.966,6s17.418-2.654,17.966-6 H60V21.375C60,24.896,51.941,27.75,42,27.75z"
  }), React.createElement("path", {
    style: {
      fill: "#61B872"
    },
    d: "M24,21v0.375c0-0.126,0.013-0.251,0.034-0.375H24z"
  }), React.createElement("path", {
    style: {
      fill: "#61B872"
    },
    d: "M59.966,21C59.987,21.124,60,21.249,60,21.375V21H59.966z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data.40255a18.svg";
export { ForwardRef as ReactComponent };